import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ManagementService } from 'src/app/management/services/management.service';

@Component({
  selector: 'app-edit-delete-button-renderer',
  templateUrl: './edit-delete-button-renderer.component.html',
  styleUrls: ['./edit-delete-button-renderer.component.scss']
})
export class EditDeleteButtonRendererComponent implements ICellRendererAngularComp {

  params: any;

  idString = '';

  domain_mgmt_enabled: boolean;
 
  domain_tiers_enabled: boolean;

  isCustomerWebhookPresent = false;

  isNewRecord = false;

  approval_flow_enabled_for_app = false;

  constructor() {

  }

  agInit(params: any): void {
    this.params = params;
    this.idString = this.params.context.componentParent.idString;
    this.domain_mgmt_enabled = this.params.context.componentParent.configOptionsOnChanges?.domain_mgmt_enabled;
    this.domain_tiers_enabled = this.params.context.componentParent.configOptionsOnChanges?.domain_tiers_enabled;
    this.isCustomerWebhookPresent = this.params.context.componentParent?.isCustomerWebhookPresent;
    // console.log(this.params);
    this.isNewRecord = this.params?.data.isNew ? true : false;
    this.approval_flow_enabled_for_app = this.params.context.componentParent?.appDetailsData?.approval_flow_enabled ? true : false;
  }

  // handleActionClickEvent(event: any) {
  //   this.params.clicked(this.params.value);
  // }

  handleActionClickEvent(event: string) {
    // this.managementService.vendorEditClickSub.next(this.params);
    this.params.context.componentParent.handleClick(event, this.params.data);
  }

  refresh(): boolean {
    return false;
  }

}
